<template>
  <div class="connect-clients-page">
    <title-component v-if="isTitleVisible">Selecteer een client</title-component>
    <ul>
      <listitem-component
        v-for="client in getAvailableClients"
        :key="client.id"
        @click.native="connectClient(client.id)"
      >{{ client.initials }}</listitem-component>
    </ul>
  </div>
</template>

<script>
import TitleComponent from '../components/title.component';
import ListitemComponent from '../components/listitem.component';
import { mapGetters } from 'vuex';
import { RouteName, Viewport } from '../utils/enums';

export default {
  name: 'connect-client-page',
  components: {
    ListitemComponent,
    TitleComponent
  },
  computed: {
    ...mapGetters(['getAvailableClients', 'getSmartwatchToConnect']),
    isTitleVisible() {
      return this.$mq !== Viewport.DESKTOP;
    }
  },
  methods: {
    connectClient(clientId) {
      this.$store.commit('SET_CLIENT_TO_CONNECT', clientId);
      this.$router.push({ name: RouteName.CONNECT_SETTINGS });
    }
  },
  created() {
    this.$store.dispatch('FETCH_CLIENTS');
  }
};
</script>
<style scoped lang="scss">
.listitem-component::v-deep {
  .listitem-icon {
    background-image: url('../assets/icons/pofile-medium-white.svg');
    background-position-y: 12px;
  }
}
</style>
